import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import PerformanceReviewCycleDetailPage from "@/pages/admin/PerformanceReviewCycleDetailPage";

export const Route = createFileRoute("/_admin/admin/performance/cycles/$id")({
  head: () => pageHead("Admin · Performance · Cycles", "AKIVA admin · performance · cycles portal.", "/admin/performance/cycles/$id", true),
  component: PerformanceReviewCycleDetailPage,
});
